<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" class="font-weight-light caption pb-0"
          >Dash > Pedido > Detalle > Checklist > CONTRATO</v-col
        >
        <v-col cols="12" class="title text-uppercase pt-1"
          >Términos de contrato de renta</v-col
        >
        <v-col cols="12" class="pb-0">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="font-weight-light">
          CONTRARO PROSIC
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique
            ullam quia asperiores sint dolore vero totam maxime explicabo
            placeat ipsam, iste minus delectus eligendi, velit dignissimos
            deleniti tempore omnis esse.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique
            ullam quia asperiores sint dolore vero totam maxime explicabo
            placeat ipsam, iste minus delectus eligendi, velit dignissimos
            deleniti tempore omnis esse.
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row id="btn-bottom">
        <v-col sm="4">
          <v-btn color="black" class="btn-contract" @click="acceptTerms()" block
            >Acepto los términos</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Checklist from "@/models/damage";

export default {
  data() {
    return {
      form: Checklist.getChecklistForm()
    };
  },
  methods: {
    acceptTerms() {
      this.form.terms.value = true;
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.btn-contract {
  background-color: #ffc800 !important;
}
</style>
